import React, { Component } from 'react';
import { Form, FormGroup, Container, Row, Col, Label, Input, Badge } from 'reactstrap';
import NavNextBack from './NavNextBack';

export default class Profile extends Component {
    constructor(props) {
        super(props)

        this.state = {
            profiles: [],
            councilDistricts: [],
            gender: [],
            ethnicity: [],
            politicalParty: [],
            county: [],
            disability: []
        };
    }

    componentDidMount() {
        // return Council District List
        fetch('/api/codes/type/councildistrict', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ councilDistricts: data });
            })

        // return Gender List
        fetch('/api/codes/type/sex', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ gender: data });
            })

        // return Ethnicity LIst
        fetch('/api/codes/type/ethnicityrace', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ ethnicity: data });
            })

        // return Political Party List
        fetch('/api/codes/type/politicalparty', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ politicalParty: data });
            })

        // return County List
        fetch('/api/codes/type/county', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ county: data });
            })

        // return Disability Choices
        fetch('/api/codes/type/disability', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ disability: data });
            })

        if (this.props.id) {
            fetch('/api/profile/' + this.props.id, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(data => {
                    this.setState({ profiles: data, editMode: true });
                })
        } 
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onClickNext();
    }


    render() {
        return (
            <div>
                <NavNextBack id="profileNav" form="profile" className="row justify-content-end my-1" next unsavedChanges={this.props.unsavedChanges} onSaveChanges={this.props.onSaveChanges} />
                <Form id="profile" onSubmit={this.handleSubmit}>

                    <FormGroup>
                        <Container className="form-border">
                            <Row>
                                <Col sm="12">
                                    <Badge
                                        color="light"
                                        className="text-dark"
                                        pill
                                    >
                                        Contact Information
                                    </Badge>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" md="6" lg="3">
                                    <FormGroup>
                                        <Label>First Name</Label>
                                        <Input className="includeInProgress" name="firstName" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.firstName || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="6" lg="3">
                                    <FormGroup>
                                        <Label>Middle Name</Label>
                                        <Input name="middleName" maxLength="50" onChange={this.props.onChange} value={this.props.profiles.middleName || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="6" lg="3">
                                    <FormGroup>
                                        <Label>Last Name</Label>
                                        <Input className="includeInProgress" name="lastName" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.lastName || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="6" lg="3">
                                    <FormGroup>
                                        <Label>Preferred Pronoun</Label>
                                        <Input name="pronoun" maxLength="10" onChange={this.props.onChange} value={this.props.profiles.pronoun || ''} />
                                    </FormGroup>
                                </Col>
                            </Row>    
                            <Row>
                                <Col sm="12" md="12" lg="3">
                                    <FormGroup>
                                        <Label>Care Of</Label>
                                        <Input name="careOf" maxLength="50" onChange={this.props.onChange} value={this.props.profiles.careOf || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="12" lg="3">
                                    <FormGroup>
                                        <Label>Occupation</Label>
                                        <Input name="occupation" maxLength="50" onChange={this.props.onChange} value={this.props.profiles.occupation || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="12" lg="3">
                                    <FormGroup>
                                        <Label>Website</Label>
                                        <Input name="website" maxLength="50" onChange={this.props.onChange} value={this.props.profiles.website || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="12" lg="3">
                                    <FormGroup>
                                        <Label>County</Label>
                                        <Input type="select" className="includeInProgress" name="county" required onChange={this.props.onChange} value={this.props.profiles.county || ''}>
                                            <option value=''></option>
                                            {this.state.county.length > 0 &&
                                                this.state.county.filter(c => c.isActive === true || this.state.profiles.county === c.id).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Home Street Address</Label>
                                        <Input className="includeInProgress" name="mailingAddress1" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.mailingAddress1 || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Home Street Address 2</Label>
                                        <Input name="mailingAddress2" maxLength="50" onChange={this.props.onChange} value={this.props.profiles.mailingAddress2 || ''} />
                                    </FormGroup>
                                </Col>
                            </Row> 
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>City</Label>
                                        <Input className="includeInProgress" name="mailingCity" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.mailingCity || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>State</Label>
                                        <Input className="includeInProgress" name="mailingState" required maxLength="2" onChange={this.props.onChange} value={this.props.profiles.mailingState || ''}/>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Zip Code</Label>
                                        <Input className="includeInProgress" name="mailingZip" required maxLength="10" onChange={this.props.onChange} value={this.props.profiles.mailingZip || ''} />
                                    </FormGroup>
                                </Col>
                            </Row>  
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Do you live in an unincorporated area?</Label>
                                        <br />
                                        <FormGroup check inline id="addressUnincorporatedRadio" className={!this.props.profiles.addressUnincorporated ? "required-radio" : ""}>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="addressUnincorporated" checked={this.props.profiles.addressUnincorporated === "true"} value="true" onChange={this.props.onChange} />{' '}Yes
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="addressUnincorporated" checked={this.props.profiles.addressUnincorporated === "false"} value="false" onChange={this.props.onChange} />{' '}No
                                            </Label>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                {this.props.profiles.addressUnincorporated === "false" &&
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Municipality</Label>
                                            <Input className="includeInProgress" name="municipality" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.municipality || ''} />
                                        </FormGroup>
                                    </Col>
                                }
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>County Council District</Label>
                                        <Input type="select" className="includeInProgress" name="councilDistrict" required onChange={this.props.onChange} value={this.props.profiles.councilDistrict || ''}>
                                            <option value=''></option>
                                            {this.state.councilDistricts.length > 0 &&
                                                this.state.councilDistricts.filter(c => c.isActive === true || this.state.profiles.councilDistrict === c.id).map((item, i) => {                                                    
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )                                                    
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Home Phone Number</Label>
                                        <Input className="includeInProgress" name="homePhone" required pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' placeholder="###-###-####" onChange={this.props.onChange} value={this.props.profiles.homePhone || ''} />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Cell Phone Number</Label>
                                        <Input className="includeInProgress" name="mobilePhone" pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' placeholder="###-###-####" onChange={this.props.onChange} value={this.props.profiles.mobilePhone || ''}/>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Email Address</Label>
                                        <Input className="includeInProgress" name="email" required pattern='^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$' onChange={this.props.onChange} value={this.props.profiles.email || ''}/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Political Party</Label>
                                        <Input type="select" className="includeInProgress" name="politicalParty" required onChange={this.props.onChange} value={this.props.profiles.politicalParty || ''}>
                                            <option value=''></option>
                                            {this.state.politicalParty.length > 0 &&
                                                this.state.politicalParty.filter(c => c.isActive === true || this.state.profiles.politicalParty === c.id).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Spouse's Full Name</Label>
                                        <Input className="includeInProgress" name="spouseName" maxLength="75" onChange={this.props.onChange} value={this.props.profiles.spouseName || ''} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Are you registered to vote at the above home address?</Label>
                                        <br />
                                        <FormGroup check inline id="votingRegistrationAtHomeRadio" className={!this.props.profiles.votingRegistrationAtHome ? "required-radio" : ""}>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="votingRegistrationAtHome" checked={this.props.profiles.votingRegistrationAtHome === "true"} value="true" onChange={this.props.onChange} />{' '}Yes
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="votingRegistrationAtHome" checked={this.props.profiles.votingRegistrationAtHome === "false"} value="false" onChange={this.props.onChange} />{' '}No
                                            </Label>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Are you a United States Citizen?</Label>
                                        <br />
                                        <FormGroup check inline id="uscitizenRadio" className={!this.props.profiles.uscitizen ? "required-radio" : ""}>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="uscitizen" checked={this.props.profiles.uscitizen === "true"} value="true" onChange={this.props.onChange} />{' '}Yes
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="uscitizen" checked={this.props.profiles.uscitizen === "false"} value="false" onChange={this.props.onChange} />{' '}No
                                            </Label>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Are you a St. Louis County Resident?</Label>
                                        <br />
                                        <FormGroup check inline id="countyResidentRadio" className={!this.props.profiles.countyResident ? "required-radio" : ""}>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="countyResident" checked={this.props.profiles.countyResident === "true"} value="true" onChange={this.props.onChange} />{' '}Yes
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="countyResident" checked={this.props.profiles.countyResident === "false"} value="false" onChange={this.props.onChange} />{' '}No
                                            </Label>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Container>
                    </FormGroup>

                    <FormGroup>
                        <Container className="form-border">       
                            <Row>
                                <Col sm="12">
                                    <Badge
                                        color="light"
                                        className="text-dark"
                                        pill
                                    >
                                        Military Service
                                    </Badge>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label>
                                            Are you, or have you ever been, a member of the armed forces of the United States? If so, please list
                                            dates of service, branch of service, rank and type of discharge.
                                        </Label>
                                        <br />
                                        <FormGroup check inline id="militaryRadio" className={!this.props.profiles.military ? "required-radio" : ""}>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="military" checked={this.props.profiles.military === "true"} value="true" onChange={this.props.onChange} />{' '}Yes
                                                </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="radio" className="includeInProgress" required name="military" checked={this.props.profiles.military === "false"}  value="false" onChange={this.props.onChange} />{' '}No
                                                </Label>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {this.props.profiles.military === "true" &&
                                <div>
                                    <Row>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Military Service</Label>
                                                <Input className="includeInProgress" name="militaryService" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.militaryService || ''} />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Military Branch</Label>
                                                <Input className="includeInProgress" name="militaryBranch" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.militaryBranch || ''} />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Military Rank</Label>
                                                <Input className="includeInProgress" name="militaryRank" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.militaryRank || ''} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Type of Discharge</Label>
                                                <Input className="includeInProgress" name="militaryTypeOfDischarge" required maxLength="50" onChange={this.props.onChange} value={this.props.profiles.militaryTypeOfDischarge || ''} />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Service Start Date</Label>
                                                <Input type="date" className="includeInProgress" required name='militaryServiceStartDate' value={this.props.profiles.militaryServiceStartDate || ''} onChange={this.props.onChange} max="9999-12-31" />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label>Service End Date</Label>
                                                <Input type="date" className="includeInProgress" required name='militaryServiceEndDate' value={this.props.profiles.militaryServiceEndDate || ''} onChange={this.props.onChange} max="9999-12-31"/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }                                
                        </Container>
                    </FormGroup>

                    <FormGroup>
                        <Container className="form-border">
                            <Row>
                                <Col sm="12">
                                    <Badge
                                        color="light"
                                        className="text-dark"
                                        style={{ whiteSpace: "normal" }}
                                        pill
                                    >
                                        *This information will be used to provide demographic statistics. Providing this information is voluntary.
                                    </ Badge>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>*Gender</Label>
                                        <Input type="select" className="includeInProgress" required name="genderSex" onChange={this.props.onChange} value={this.props.profiles.genderSex}>
                                            <option value=''></option>
                                            {this.state.gender.length > 0 &&
                                                this.state.gender.filter(c => c.isActive === true || this.props.profiles.gender === c.id).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>*Ethnicity</Label>
                                        <Input type="select" className="includeInProgress" required name="ethnicityRace" onChange={this.props.onChange} value={this.props.profiles.ethnicityRace}>
                                            <option value=''></option>
                                            {this.state.ethnicity.length > 0 &&
                                                this.state.ethnicity.filter(c => c.isActive === true || this.props.profiles.ethnicity === c.id).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>*Do you have a disability?</Label>
                                        <Input type="select" className="includeInProgress" required name="disability" onChange={this.props.onChange} value={this.props.profiles.disability}>
                                            <option value=''></option>
                                            {this.state.disability.length > 0 &&
                                                this.state.disability.filter(c => c.isActive === true || this.props.profiles.disability === c.id).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.description}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Container>
                    </FormGroup>

                </Form>
                <NavNextBack id="profileNav" form="profile" className="row justify-content-end my-1" next unsavedChanges={this.props.unsavedChanges} onSaveChanges={this.props.onSaveChanges}/>
            </div>
        )
    }
}